import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { BarOwnerDataProvider } from "../../context/BarOwnerDataContext";
import Dashboard from "./pages/Dashboard";
import Calendar from "./pages/Calendar";
import Artists from "./pages/Artists";
import Financials from "./pages/Financials";
import Management from "./pages/Management";
import Settings from "./pages/Settings";
import Notifications from "./pages/Notifications";
import Messages from "./pages/Messages";

const BarAdminRoutes = () => {
  return (
    <BarOwnerDataProvider>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />

        <Route path="/calendar" element={<Calendar />} />
        <Route path="/artists" element={<Artists />} />
        <Route path="/financials" element={<Financials />} />

        <Route path="/management" element={<Management />} />
        <Route path="/settings" element={<Settings />} />

        <Route path="/notifications" element={<Notifications />} />
        <Route path="/messages" element={<Messages />} />

        <Route path="*" element={<Navigate to="/bar-admin" replace />} />
      </Routes>
    </BarOwnerDataProvider>
  );
};

export default BarAdminRoutes;
